import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Filter } from '../models/table-models';
import { Pagination } from '../utils/pagination-hooks';

export interface SearchComponentProps {
    filter: Filter;
    setFilter: React.Dispatch<React.SetStateAction<Filter>>;
    label?: boolean;
    pagination: Pagination;
    applyOnChange?: boolean;
    onSearch?: (searchValue: string) => void;
    separateSubmitButton?: boolean;
    hideSubmitButton?: boolean;
    formId?: string;
}

export const SearchComponent = ({
    filter,
    setFilter,
    label,
    pagination,
    applyOnChange = true,
    onSearch,
    separateSubmitButton = false,
    hideSubmitButton = false,
    formId,
}: SearchComponentProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { setCurrentPage } = pagination;

    const [searchValue, setSearchValue] = useState(filter.search ?? '');

    useEffect(() => {
        setSearchValue(filter.search ?? '');
    }, [filter.search]);

    const updateFilterSearch = (value: string) => {
        setFilter((prev) => ({ ...prev, search: value }));
        setCurrentPage(1);
    };

    const executeSearch = () => {
        updateFilterSearch(searchValue);
        onSearch?.(searchValue);
    };

    const handleChange = (value: string) => {
        setSearchValue(value);

        if (applyOnChange && (value.length > 2 || value.length === 0)) {
            updateFilterSearch(value);
        }
    };

    return (
        <Form
            id={formId}
            noValidate
            className={`w-30 d-flex search-container rounded mt-1 ${
                separateSubmitButton
                    ? 'align-items-end justify-content-end gap-2'
                    : 'align-items-center justify-content-end'
            }`}
            onSubmit={(event) => {
                event.preventDefault();
                executeSearch();
            }}
        >
            <Form.Group className=' flex-center search w-100 align-items-start' controlId='searchForm'>
                {label && <Form.Label className='form-label mb-1 fw-bold fs-5 px-2'>{t('search')}</Form.Label>}
                <Form.Control
                    type='search'
                    className='form-control shadow-none '
                    value={searchValue}
                    onChange={(e) => handleChange(e.target.value)}
                ></Form.Control>

                {!separateSubmitButton && !hideSubmitButton && (
                    <Button type='submit' className='btn btn-primary'>
                        <FontAwesomeIcon icon={faSearch} className='fa-fw' />
                    </Button>
                )}
            </Form.Group>

            {separateSubmitButton && !hideSubmitButton && (
                <Button type='submit' className='btn btn-primary flex-shrink-0'>
                    <FontAwesomeIcon icon={faSearch} className='fa-fw' />
                </Button>
            )}
        </Form>
    );
};
